import ReviewsStoreBase from "@apps/reviews/stores/ReviewsStoreBase";

class ReviewsStore extends ReviewsStoreBase {}

export default ReviewsStore;